import { AccountInfo, DeviceInfo, LOGINTYPE, defaultAccountInfo, defaultDeviceInfo } from '@/entities/base';
import { getCookie, isQQBrowser } from '@/modules/util';
import axios from 'axios';
import { camelizeKeys } from 'humps';
import { getLoginInfo, isGetLoginInfoExist } from '@/modules/nativeApi';

const storeInfo: {
  accountInfo: AccountInfo,
  deviceInfo: DeviceInfo,
} = {
  accountInfo: defaultAccountInfo,
  deviceInfo: defaultDeviceInfo,
};

async function getUser() {
  let userInfo;
  try {
    if (isQQBrowser() && isGetLoginInfoExist()) {
      console.log('🚀 ~ file: auth.ts:23 ~ getUser ~ isQQBrowser:', isQQBrowser());
      const res = await getLoginInfo();
      console.log('🚀 ~ file: auth.ts:25 ~ getUser ~ res:', res);
      userInfo = res;
    } else {
      const {
        tguid,
        qimei36,
        qua2,
      } = getDeviceInfo();
      const response = await axios.get(`/api/getLoginInfo?userInfo=${JSON.stringify({
        guid: tguid,
        qimei36,
        qua2,
      })}`);
      userInfo = response?.data?.data;
    }
    console.log('response', userInfo);
    return camelizeKeys(userInfo);
  } catch (error) {
    console.error(error);
  }
}


const getAccountInfo = async () => {
  const response = await getUser() as AccountInfo;
  if (response.logintype === LOGINTYPE.QQ) {
    response.type = 4;
  } else {
    response.type = 2;
  }
  response.uin = response.openid;
  response.token = response.accessToken;
  return response;
};

const getDeviceInfo = () => {
  // @ts-ignore
  const guid = window?.external?.getGuid?.();
  // @ts-ignore
  const tguid = window?.external?.getFavSyncGuid?.() || getCookie('_t_qbtool_uid');
  // @ts-ignore
  const qimei36 = window?.external?.getQ36?.() || getCookie('_qimei_q36');
  // @ts-ignore
  const qimei32 = window?.external?.getQ16?.();
  const qua2 = '';
  return {
    guid,
    tguid,
    qimei36,
    qua2,
    qimei32,
  };
};


export const useAuth = {
  fetch: async () => {
    if (!storeInfo?.deviceInfo?.guid) {
      try {
        storeInfo.deviceInfo = getDeviceInfo();
      } catch (error) {
        console.log('🚀 ~ file: auth.ts:19 ~ fetch: ~ error:', error);
      }
    }
    if (!storeInfo?.accountInfo?.qbid) {
      try {
        const accountInfo: AccountInfo = await getAccountInfo();
        console.log('🚀 ~ file: auth.ts:70 ~ fetch: ~ accountInfo:', accountInfo);
        storeInfo.accountInfo = accountInfo;
      } catch (error) {
        console.log('🚀 ~ file: auth.ts:26 ~ fetch: ~ error:', error);
      }
    }
  },
  fetchDevice: async () => {
    if (storeInfo.deviceInfo.guid) {
      console.log('已获取对应登录信息 storeInfo ----->', storeInfo);
      return;
    }
  },
  storeInfo: () => {
    return storeInfo;
  },
};
